// extracted by mini-css-extract-plugin
module.exports = {"s1231mjs":"s1231mjs"};